/** One authoritative simulation cadence shared by ticker, ECS, and physics. */
export const FIXED_TIMESTEP_HZ = 60;
export const FIXED_TIMESTEP_MS = 1000 / FIXED_TIMESTEP_HZ;
export const FIXED_TIMESTEP_SECONDS = 1 / FIXED_TIMESTEP_HZ;
